// src/modules/app-views/services/pages/Document/tabs/AiInfoTab/AiMetaSection.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Descriptions, Collapse, Tag, theme } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import dayjs from 'dayjs';
import { DEFAULT_OPEN_KEYS } from './index';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const AiMetaSection = ({ data, isMobile }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { token } = theme.useToken();
  const ai = data?.aiCatalogMeta;

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES
  // ─────────────────────────────────────────────────────────────────────────────
  const hasData = ai && ai.catalogedByAI;

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!hasData) return null;

  return (
    <Collapse
      className="collapsed-content-fit"
      defaultActiveKey={DEFAULT_OPEN_KEYS.includes('ai-meta') ? ['ai-meta'] : []}
      style={{ marginBottom: 16 }}
      items={[
        {
          key: 'ai-meta',
          label: (
            <Flex align="center" gap={8}>
              <RobotOutlined style={{ color: token.colorPrimary }} />
              <span style={{ fontWeight: 600 }}>{translateX('ai_cataloging_info')}</span>
            </Flex>
          ),
          showArrow: false,
          children: (
            <Descriptions
              bordered
              size="small"
              column={1}
              layout={isMobile ? 'vertical' : 'horizontal'}
              styles={{ label: { fontWeight: 500 } }}
            >
              <Descriptions.Item label={translateX('provider')}>
                {ai.provider?.toUpperCase()}
              </Descriptions.Item>
              <Descriptions.Item label={translateX('model')}>
                {ai.model}
              </Descriptions.Item>
              <Descriptions.Item label="Tokens">
                {ai.totalTokens?.toLocaleString()} ({translateX('input')}: {ai.inputTokens?.toLocaleString()}, {translateX('output')}: {ai.outputTokens?.toLocaleString()})
              </Descriptions.Item>
              <Descriptions.Item label={translateX('response_time')}>
                {(ai.responseTimeMs / 1000).toFixed(1)}s
              </Descriptions.Item>
              <Descriptions.Item label={translateX('credits_debited')}>
                {ai.finalCostBRL ? Math.ceil(ai.finalCostBRL * 10) : '-'} {translateX('credits')}
              </Descriptions.Item>
              <Descriptions.Item label={translateX('cataloged_at')}>
                {ai.catalogedAt ? dayjs(ai.catalogedAt).format('DD/MM/YYYY HH:mm:ss') : '-'}
              </Descriptions.Item>
              <Descriptions.Item label={translateX('manually_reviewed')}>
                {ai.manuallyReviewed ? (
                  <Tag color="green">{translateX('yes')}</Tag>
                ) : (
                  <Tag color="orange">{translateX('no')}</Tag>
                )}
              </Descriptions.Item>
            </Descriptions>
          ),
        },
      ]}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default AiMetaSection;
